import * as React from "react"
import { useTracker } from "@modules/analytics"
import { useToggleIncrementalDeploysProduction } from "../hooks/useToggleIncrementalDeploysProduction"
import { siteBuildsSettings as text } from "@modules/locales/default.js"
import { Link, Spacer, ToggleCheckbox } from "gatsby-interface"
import { FormattedMessage } from "@modules/locales"
import { MdInfoOutline, MdArrowForward } from "react-icons/md"
import { useSiteDependencyInfo } from "../hooks/useSiteDependencyInfo"

export type EnableIncrementalDeploysProductionProps = {
  siteId: string
  enabled: boolean
}

export function EnableIncrementalDeploysProduction({
  siteId,
  enabled,
}: EnableIncrementalDeploysProductionProps): JSX.Element {
  const [toggleIncrementalDeploysProduction, { errorAlert }] =
    useToggleIncrementalDeploysProduction(siteId)
  const { trackButtonClicked } = useTracker()
  const { isCompatibleGatsbyVersion } = useSiteDependencyInfo(siteId)

  const readMoreLink = `https://support.gatsbyjs.com/hc/en-us/articles/4496156103571`

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-incremental-deploys-checkbox"
        label={
          <React.Fragment>
            {text.labels.enableIncrementalDeploysProduction}
            <Spacer direction="horizontal" size={3} />
            <Link href={readMoreLink}>
              <MdInfoOutline />
            </Link>
            <Spacer direction="horizontal" size={3} />
          </React.Fragment>
        }
        hint={
          <React.Fragment>
            {text.messages.enableIncrementalDeploysProduction}
            {". "}
            {!isCompatibleGatsbyVersion ? (
              <FormattedMessage
                message={text.messages.incDeploysRequiresLatestGatsbyVersion}
                tags={{
                  link: function (content: string) {
                    return (
                      <Link to={readMoreLink} variant="SIMPLE">
                        {content} <MdArrowForward />
                      </Link>
                    )
                  },
                }}
              />
            ) : (
              text.messages.incDeploysDefaultBanner
            )}
          </React.Fragment>
        }
        checked={!!enabled}
        onChange={() => {
          trackButtonClicked(`update incremental deploys`, {
            uiSource: `Site Settings`,
          })
          toggleIncrementalDeploysProduction()
        }}
        disabled={!isCompatibleGatsbyVersion}
      />
      {errorAlert}
    </React.Fragment>
  )
}
